import type {
  PortType,
  PortTypeApi,
  PortTypeFilters,
  PortTypeFiltersUpdateApi,
  PortTypes,
  PortTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizePortType = (portType: PortTypeApi): PortType => ({
  id: portType.codeId,
  label: portType.codeDesc,
});

export const normalizePortTypes = (response: PortTypesApi): PortTypes => {
  const list = (response.items ?? []).sort((a, b) => a.codeDesc.localeCompare(b.codeDesc)).map(normalizePortType);
  return {
    list,
    map: list.reduce(
      (acc, portType) => {
        acc[portType.id] = portType;
        return acc;
      },
      {} as PortTypes['map'],
    ),
  };
};

export const normalizePortTypeFilters = (filters: Partial<PortTypeFilters>): PortTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
